import data from './data';
import { zoom, bilinear, clearData2D } from './algorithms';
import { hexToDecimal, decimalToHex } from './helpers';

/*****************************************
 * EXPORTED FUNCTIONS
 *****************************************/

const calcFunctions = {
  clearData2D,
  data2DConvert2Draw,
  data2DrawConvert2Data2D,
  calcInit0,
  calcInit1,
  calcInit2,
  step,
};

export default calcFunctions;

// set pixel in Canvas array format
function setPx(matrix, y, x, val) {
  y *= 4;
  x *= 4;
  matrix[y * data.size.width + x] = hexToDecimal(val, 0, 2);
  matrix[y * data.size.width + x + 1] = hexToDecimal(val, 2, 4);
  matrix[y * data.size.width + x + 2] = hexToDecimal(val, 4, 6);
  matrix[y * data.size.width + x + 3] = hexToDecimal(val, 6, 8);
}

// convert 2D matrix to Canvas format
function data2DConvert2Draw(data2D, repeat = 1) {
  const picMiddle = {
    width: (data2D.width * repeat) / 2,
    height: (data2D.height * repeat) / 2,
  };

  const startX = Math.round(data.size.width / 2 - picMiddle.width);
  const startY = Math.round(data.size.height / 2 - picMiddle.height);

  const dataDraw = clearDrawData();
  for (let i = 0; i < data2D.height * repeat; i++) {
    const iSrc = Math.floor(i / repeat);
    for (let j = 0; j < data2D.width * repeat; j++) {
      const jSrc = Math.floor(j / repeat);
      setPx(dataDraw, startY + i, startX + j, data2D[iSrc][jSrc]);
    }
  }
  return dataDraw;
}
function data2DrawConvert2Data2D(dataDraw, width, height) {
  // console.table(dataDraw);
  const data2D = clearData2D({ width, height });
  for (let i = 0; i < height; i++) {
    for (let j = 0; j < width; j++) {
      let iSrc = (i * width + j) * 4;
      let val = '';
      for (let k = 0; k < 4; k++) {
        val += decimalToHex(dataDraw[iSrc + k]);
      }
      data2D[i][j] = val;
    }
  }
  data2D.width = width;
  data2D.height = height;
  return data2D;
}

/*****************************************
 * initializations
 *****************************************/

// all variables are declares in data.js

// data in Canvas format
function clearDrawData() {
  const data2Draw = new Array(data.size.height * data.size.width * 4).fill(255);
  return data2Draw;
}

// initial matrix
function calcInit0() {
  const size = { width: 2, height: 2 };
  // build 2D matrix
  let cellWidth = size.width / 2;
  let cellHeight = size.height / 2;
  const data2D = clearData2D(size);
  for (let i = 0; i < cellHeight; i++) {
    for (let j = 0; j < cellWidth; j++) {
      data2D[i][j] = '555555ff';
      data2D[i][j + cellWidth] = 'e7e7e7ff';
      data2D[i + cellWidth][j + cellHeight] = '888888ff';
      data2D[i + cellHeight][j] = 'f7f7f7ff';
    }
  }

  // 2d matrix, array to draw, current scale
  const data = {
    data2DFirst: data2D,
    data2D1: data2D,
    data2D2: data2D,
    image: false,
    src: null,
  };
  return data;
}

function calcInit1() {}

function calcInit2() {}

/**********************************************************
 * user activities
 ********************************************************* */

function step(dataSrc, scale) {
  let { data2DFirst, data2D1, data2D2 } = dataSrc;

  const size = {
    width: Math.floor(data2DFirst.width * scale),
    height: Math.floor(data2DFirst.height * scale),
  };

  data2D1 = clearData2D(size);
  bilinear(data2DFirst, data2D1, scale);
  data2D2 = zoom(data2DFirst, size, scale);

  return { data2D1, data2D2 };
}
